import React from 'react';
import styled, { css } from 'styled-components';
import { GridElem } from '../../../common/grid';
import { ReactComponent as CloseIcon } from '../../../asset/svg/close-golden.svg';

import { ModalContent, ModalOverlay } from '../../../common/modal/elem';
import { Spacing } from '../../../theme';
import { ButtonElem } from '../../../common/button';
import { MarkDown } from '../../../common/markdown/markdown';

export interface POPUP_MODAL_TEST {
  body: string;
  linkUrl?: string;
  imgUrl?: string;
}

interface PopupModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: POPUP_MODAL_TEST;
}

export const ModalPopupTestView: React.FC<PopupModalProps> = ({
  data,
  isOpen = false,
  onClose,
}) => {
  return (
    <ModalOverlay>
      <ModalContentStyled open={isOpen}>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
        <Container spacing={0}>
          {data.imgUrl && <Img src={data.imgUrl} />}

          <Content>
            <MarkDown tid={data.body} />

            <GridElemStyled isLink={!!data.linkUrl}>
              {data.linkUrl && (
                <ButtonElem
                  type="primary"
                  onClick={() =>
                    window.open(data.linkUrl, '_blank', 'noopener,noreferrer')
                  }
                  tid="POPUP.BUTTON.STUDY"
                />
              )}

              <ButtonElem
                onClick={onClose}
                type="submit"
                tid="POPUP.BUTTON.VIEWED"
              />
            </GridElemStyled>
          </Content>
        </Container>
      </ModalContentStyled>
    </ModalOverlay>
  );
};

const ModalContentStyled = styled(ModalContent)<{ open: boolean }>`
  padding: ${Spacing(0)};
  border-radius: 12px;
  max-height: 85%;

  border: 1px solid rgba(244, 225, 135, 0.4);
  box-shadow: 0 0 50px #00000080;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    opacity: 0.7;
  }
`;
const Container = styled(GridElem)``;

const GridElemStyled = styled(GridElem)<{ isLink: boolean }>`
  gap: ${Spacing(0)};
  ${({ isLink }) =>
    isLink &&
    css`
      gap: ${Spacing(3)};
    `}
`;

const Content = styled.div`
  display: grid;
  padding: ${Spacing(6)} ${Spacing(5)};
  width: 100%;
  gap: ${Spacing(6)};
`;

const Img = styled.img`
  border-radius: 11px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;

  min-height: 200px;
  max-height: 200px;
  object-fit: cover;
  width: 100%;
`;
